/* eslint-disable no-unused-expressions */
/* eslint-disable no-plusplus */
/**
 * Slider shared block scripts
 * This file gets shared between the
 * theme and editor.
 */

const slider = (els) => {
	// loop through all the sliders and slides
	if (els.length) {
		els.forEach((el) => {
			const slides = el.querySelectorAll('.slider-item')
			const count = slides.length
			if (count) {
				// determine if we're at desktop-ish
				const isDesktop = window.innerWidth >= 782
				// start at first slide
				let cur = 0
				// prep to store any autoplay videos
				const autoplayable = {}
				// get the button controls
				const prev = el.querySelector('.slider__button--prev')
				const next = el.querySelector('.slider__button--next')

				// go to slide at index
				const setSlide = (index) => {
					// use zero indexed count
					const countZ = count - 1
					// enable/disable buttons
					prev.disabled = index <= 0 ? 'disabled' : false
					next.disabled = index >= countZ ? 'disabled' : false
					// don't go to non-existent slides
					if (index > countZ) {
						cur = countZ
						return
					}
					if (index < 0) {
						cur = 0
						return
					}
					// for each slide
					slides.forEach((slide, i) => {
						// apply active/inactive classes
						slide.classList.toggle('is-pre', i < index)
						slide.classList.toggle('is-active', i === index)
						slide.classList.toggle('is-post', i > index)
						// play any autoplay videos
						if (isDesktop && autoplayable[i]) {
							i === index ? autoplayable[i].play() : autoplayable[i].pause()
						}
					})
				}

				// bind controls
				prev.addEventListener('click', () => setSlide(--cur))
				next.addEventListener('click', () => setSlide(++cur))
				document.onkeydown = (e) => {
					e.key === 'ArrowLeft' && setSlide(--cur)
					e.key === 'ArrowRight' && setSlide(++cur)
				}

				// for each slide
				slides.forEach((slide, i) => {
					// add "x of y" counts to each slide (and activate first one)
					const span = document.createElement('span')
					span.classList.add('slider-item__count')
					span.textContent = `${i + 1} of ${count}`
					slide.append(span)

					// handle any videos
					if (isDesktop) {
						const vid = slide.querySelector('video')
						if (vid) {
							vid.pause()
							autoplayable[i] = vid
						}
					}
				})
				// activate slide 1
				setSlide(0)

				// set up close to go back if we were on our site (defaults to home page)
				const back = el.querySelector('.slider__back')
				if (document.referrer && document.referrer.includes(window.location.origin)) {
					back.href = document.referrer
				}
			}
		})
	}
}

slider(document.querySelectorAll('.slider'))
